import TDefaultEntry from './index.vue';

TDefaultEntry.install = app => {
  app.component(TDefaultEntry.name, TDefaultEntry);
};

export default TDefaultEntry;
